var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrito24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43344 3.19611C1.61215 2.82244 2.05995 2.66439 2.43363 2.8431L4.96363 4.0531C5.16599 4.14989 5.31441 4.33216 5.36817 4.54994L7.55078 13.3905C7.69233 14.0017 8.24037 14.4397 8.87004 14.4397H17.84C18.4803 14.4397 19.0333 13.9924 19.1674 13.3794L19.1678 13.3775L20.6278 6.78748L20.6287 6.78349C20.6694 6.60445 20.5308 6.41971 20.33 6.41971H9.25004C8.83582 6.41971 8.50004 6.08392 8.50004 5.66971C8.50004 5.25549 8.83582 4.91971 9.25004 4.91971H20.33C21.4686 4.91971 22.3496 5.97365 22.0919 7.11379L22.0914 7.11592L20.6327 13.7C20.3465 15.0066 19.1795 15.9397 17.84 15.9397H8.87004C7.54166 15.9397 6.39121 15.0204 6.09069 13.7346L3.99682 5.25344L1.78645 4.19631C1.41277 4.01759 1.25472 3.56979 1.43344 3.19611Z",
    fill: "#2664C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66004 18.8097C9.1188 18.8097 8.68004 19.2485 8.68004 19.7897C8.68004 20.3309 9.1188 20.7697 9.66004 20.7697C10.2013 20.7697 10.64 20.3309 10.64 19.7897C10.64 19.2485 10.2013 18.8097 9.66004 18.8097ZM7.18004 19.7897C7.18004 18.42 8.29037 17.3097 9.66004 17.3097C11.0297 17.3097 12.14 18.42 12.14 19.7897C12.14 21.1594 11.0297 22.2697 9.66004 22.2697C8.29037 22.2697 7.18004 21.1594 7.18004 19.7897Z",
    fill: "#2664C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.05 18.8097C16.5088 18.8097 16.07 19.2485 16.07 19.7897C16.07 20.3309 16.5088 20.7697 17.05 20.7697C17.5913 20.7697 18.03 20.3309 18.03 19.7897C18.03 19.2485 17.5913 18.8097 17.05 18.8097ZM14.57 19.7897C14.57 18.42 15.6804 17.3097 17.05 17.3097C18.4197 17.3097 19.53 18.42 19.53 19.7897C19.53 21.1594 18.4197 22.2697 17.05 22.2697C15.6804 22.2697 14.57 21.1594 14.57 19.7897Z",
    fill: "#2664C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44004 15.9397C7.06425 15.9397 6.76004 16.2439 6.76004 16.6197C6.76004 16.9955 7.06425 17.2997 7.44004 17.2997H16.79C17.2043 17.2997 17.54 17.6355 17.54 18.0497C17.54 18.4639 17.2043 18.7997 16.79 18.7997H7.44004C6.23583 18.7997 5.26004 17.8239 5.26004 16.6197C5.26004 15.4155 6.23582 14.4397 7.44004 14.4397H16.8C17.2142 14.4397 17.55 14.7755 17.55 15.1897C17.55 15.6039 17.2142 15.9397 16.8 15.9397H7.44004Z",
    fill: "#2664C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito24X24);
export default __webpack_public_path__ + "static/media/CARRITO_24X24.b0703aa33e2db67137c005a6038fafbf.svg";
export { ForwardRef as ReactComponent };